import {Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-datepicker-id-format',
  templateUrl: './datepicker-id-format.component.html',
  styleUrls: ['./datepicker-id-format.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    { provide: MAT_DATE_LOCALE, useValue: 'pl-PL' },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    {provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => DatepickerIdFormatComponent)}
  ],
})
export class DatepickerIdFormatComponent implements ControlValueAccessor, OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() control?: FormControl;
  @Input() required: boolean;
  @Input() label: string;
  @Input() placeholder: string;

  value?: any = null;
  disabled = false;

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(
  ) {
  }

  ngOnInit(): void {
    if (!this.control) {
      this.control = new FormControl('');
    }

    this.control.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(data => {
        if (data) {
          this.value = data;
          this.onChange(data);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }

    this.disabled = isDisabled;
  }

  writeValue(value): void {
    this.control.setValue(value);
    this.value = value;
  }
}
